<template>
<ul :class="[$style.list, isRoot && $style.root]">
    <li
        v-for="{
            text,
            to,
            href,
            children,
            exact,
            path,
            version,
            isLatest
        } in items"
        v-show="isCurrentPageVersion(path, version, isLatest)"
        :key="to"
        @click="$emit('click', $event, path || to)">
        <component
            :is="href ? 'a' : 'router-link'"
            :to="to"
            :exact="exact"
            :href="href">
            {{ text }}
        </component>
        <sidebar-links
            v-if="children"
            v-show="!hasCloseFeature || isOpenedItem(to)"
            :class="$style.children"
            :depth="depth + 1"
            :items="children" />
    </li>
</ul>
</template>

<script>
export default {
    name: "SidebarLinks",
    props: {
        items: { type: Array, default: () => [] },
        depth: { type: Number, default: 0 },
        hasCloseFeature: { type: Boolean, default: false },
        versions: { type: Array, default: null }
    },
    data() {
        return {
            openedItemPath: ""
        };
    },
    computed: {
        isRoot() {
            return this.depth === 0;
        },
        currentPageName() {
            return this.$route.params.name;
        },
        currentPageVersion() {
            return this.$route.params.version;
        }
    },
    watch: {
        $route: {
            handler(to, from) {
                if (to.path !== from?.path && this.hasCloseFeature) {
                    this.setOpenedItem(to.path);
                }
            },
            immediate: true
        }
    },
    methods: {
        isOpenedItem(to) {
            return this.openedItemPath === to;
        },
        setOpenedItem(to) {
            this.openedItemPath = to;
        },
        isCurrentPageVersion(path, version, isLatest) {
            if (version) {
                const isCurrentPage = path.includes(this.currentPageName);
                const isCurrentVersion = path.includes(this.currentPageVersion);
                return isCurrentPage ? isCurrentVersion : isLatest;
            }
            return true;
        }
    }
};
</script>

<style lang="scss" module>
@use "@material/typography/typography";

.list {
    :not(li) > & {
        padding: 17px 0;
    }
    &.root > li > a {
        font-weight: bold;
    }
    &.children {
        a::before {
            content: "";
            width: 10px;
            flex: none;
        }
    }
    a {
        display: flex;
        padding: 10px 10px 10px 30px;
        font-size: typography.px-to-rem(14px);
        min-height: typography.px-to-rem(40px);
        color: #000;
        height: fit-content;
        white-space: normal;
        word-break: break-word;
        cursor: pointer;
        &:hover {
            background-color: rgba(0, 0, 0, 0.05);
        }
        &:global(.router-link-active) {
            color: #1177ef;
            background-color: #ebf5ff;
            font-weight: bold;
        }
    }
}
</style>
